/*
 * Records are numbered per page rather than by absolute position in the result
 * set: with 113 records the second page reads "Showing 1-13 of 113 records".
 * antd's Pagination hands `showTotal` the absolute range, so the count of rows
 * on the current page is that range's width.
 */
export const getRecordCountLabel = (total: number, range: [number, number]) => {
  const onThisPage = range[1] - range[0] + 1;

  return onThisPage > 0
    ? `Showing 1-${onThisPage.toLocaleString()} of ${total.toLocaleString()} records`
    : `Showing 0 of ${total.toLocaleString()} records`;
};
